<template>
  <div>
    <el-dialog
        title="Guide"
        :lock-scroll="false"
        :visible.sync="visible"
        width="860px"
        top="6vh"
        @opened="focus"
        @close="closeHandler"
        :close-on-press-escape="hideByEsc">
    <div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="快捷键" name="hotKey"><hot-key @editing="editingHandler" :focusID="focusID" /></el-tab-pane>
        <el-tab-pane label="远程节点" name="remoteNode">Coming soon</el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import hotKey from "./hotKey.vue"

export default {
  name: "guide",
  components: { hotKey },
  data() {
    return {
      visible: false,
      hideByEsc: true,
      focusID: 'guide-dialog-focus',
      activeName: "hotKey",
    }
  },
  watch: {
    activeName: function(newVal, oldVal) {
      if (oldVal === "hotKey") {
        this.env.ui.editingHotKeyCancel()
      }
    }
  },
  mounted() {
    let self = this
    this.env.ui.showGuideAddCallback(() => {self.show()})
  },
  methods: {
    show: function() {
      this.visible = true
    },
    hide: function() {
      this.visible = false
    },
    focus: function() {
      this.utils.domFocusById(this.focusID)
    },
    editingHandler: function(isEditing) {
      // console.log("guide editing")
      if (isEditing) {
        this.hideByEsc = false
      } else {
        this.hideByEsc = true
      }
    },
    closeHandler: function() {
      this.$emit('close')

      // 通知移除快捷键编辑状态下监听的 dom 事件
      this.env.ui.editingHotKeyCancel()
    }
  },
}
</script>

<style scoped>
</style>
